import { useState, useEffect } from "react";

const setItem = (key, value, numberOfDays) => {
  const now = new Date();
  now.setTime(now.getTime() + numberOfDays * 24 * 60 * 60 * 1000);
  document.cookie = `${key}=${encodeURIComponent(
    value
  )}; expires=${now.toUTCString()}; path=/`;
};

const getItem = (key) =>
  document.cookie.split("; ").reduce((total, currentCookie) => {
    const [storedKey, storedValue] = currentCookie.split("=");
    return key === storedKey ? decodeURIComponent(storedValue) : total;
  }, "");

const useCookie = (key, defaultValue, numberOfDays = 60) => {
  // Initialize from cookie or default
  const [cookie, setCookieState] = useState(() => {
    const stored = getItem(key);
    if (stored) return stored;

    // If cookie doesn't exist, create it
    setItem(key, defaultValue, numberOfDays);
    return defaultValue;
  });

  const updateCookie = (value, days = numberOfDays) => {
    setCookieState(value);
    setItem(key, value, days);
  };

  return [cookie, updateCookie];
};

export { useCookie };
